export default __webpack_public_path__ + "static/media/step-3.6f8c2e66.png";